import {ColumnTypeEnumeration} from './column-type.enumeration';
import {DatatableColumn} from './datatable-column';
import {AlignColumnsEnumeration} from './align-columns.enumeration';

export class SelectColumn extends DatatableColumn {
  multiple: boolean;
  enumeration: any;

  constructor(name: string, label: string, enumeration: any, multiple?: boolean, alignment?: AlignColumnsEnumeration) {
    super(name, label, true);
    this.name = name;
    this.label = label;
    this.enumeration = enumeration;
    this.multiple = multiple;
    this.type = ColumnTypeEnumeration.SELECT_COLUMN;
    this.alignment = alignment ? alignment : AlignColumnsEnumeration.ALIGN_LEFT;
  }
}
